import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PrimaryButton } from './PrimaryButton';
import { formatMicrograms } from '../../utils/rekovelleDose';
import { penClipUrl } from '../../data/teaser';
type PenScreenProps = {
  dose: number;
  onNext: () => void;
  /** Show the clip's first frame without playing (used for still previews). */
  paused?: boolean;
};
type ClipState = 'loading' | 'ready' | 'error';
export function PenScreen({
  dose,
  onNext,
  paused = false
}: PenScreenProps) {
  const [clip, setClip] = useState<ClipState>('loading');
  return <div className="flex h-full flex-col" data-id="element-754" data-mp="115gqxqxrj802">
      <div className="relative min-h-0 flex-1 overflow-hidden rounded-3xl bg-ink" data-id="element-755" data-mp="114e35rvqllod">
        {clip !== 'error' && <video src={paused ? `${penClipUrl}#t=1.2` : penClipUrl} autoPlay={!paused} muted loop playsInline preload="auto" onLoadedData={() => setClip('ready')} onError={() => setClip('error')} className="absolute inset-0 h-full w-full object-cover" aria-label="Short clip: REKOVELLE pen close-up, dose being set, brief administration moment" data-id="element-756" data-mp="w6cjb4qhlibu" />}
        <AnimatePresence data-id="element-757" data-mp="1jfiwv2h1g1xr">
          {clip === 'loading' && <motion.div key="loading" className="absolute inset-0 flex items-center justify-center" exit={{
          opacity: 0
        }} transition={{
          duration: 0.2
        }} data-id="element-758" data-mp="1oem0qjla8245">
              <span className="h-6 w-6 animate-spin rounded-full border-2 border-white/25 border-t-white" aria-label="Loading clip" data-id="element-759" data-mp="19o4sohe56dya" />
            </motion.div>}
        </AnimatePresence>
        {clip === 'error' && <div className="absolute inset-0 flex items-center justify-center p-6 text-center text-[13px] text-white/70" data-id="element-760" data-mp="14qv4t66eiack">
            The pen clip couldn’t load. The dose is still set for this patient.
          </div>}
        <div className="absolute bottom-4 left-4 rounded-full bg-white/95 px-3.5 py-2 shadow-[0_4px_16px_rgba(0,0,0,0.2)]" data-id="element-761" data-mp="vqq0j4wi7s2m">
          <p className="font-mono text-[9.5px] tracking-[0.12em] text-graphite" data-id="element-762" data-mp="2xh6uthxfldnn">STARTING DOSE</p>
          <p className="text-[18px] font-semibold leading-tight tabular-nums tracking-[-0.02em] text-rx" data-id="element-763" data-mp="2sncgku0lhqvy">{formatMicrograms(dose)}</p>
        </div>
      </div>

      <p className="mt-5 text-[28px] font-semibold leading-[1.06] tracking-[-0.03em] text-ink" data-id="element-764" data-mp="2jor1j8uc0tzx">
        Calculated for the patient.
        <br data-id="element-765" data-mp="3gd6tfbkwzfg7" />
        <span className="text-graphite" data-id="element-766" data-mp="3gdowos5zutxm">Set on the pen.</span>
      </p>

      <div className="mt-5" data-id="element-767" data-mp="3cdxy42a879ij">
        <PrimaryButton onClick={onNext} data-id="element-768" data-mp="3cdo5e6xsqo95">CONTINUE</PrimaryButton>
      </div>
    </div>;
}